(() => {
  const roots = document.querySelectorAll('[data-rm-pdp-v3]')
  if (!roots.length) return

  const pad = (num) => String(num).padStart(2, '0')

  const formatDate = (date, short = false) => {
    const weekday = date.toLocaleDateString('en-IN', { weekday: short ? 'short' : 'long' })
    const day = date.toLocaleDateString('en-IN', { day: 'numeric' })
    const month = date.toLocaleDateString('en-IN', { month: 'short' })
    return `${weekday}, <b>${day} ${month}</b>`
  }

  const addWorkingDays = (start, days) => {
    const next = new Date(start)
    let added = 0
    while (added < days) {
      next.setDate(next.getDate() + 1)
      const day = next.getDay()
      if (day !== 0) added += 1
    }
    return next
  }

  const moneyFromCents = (cents, currency) => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency || 'INR',
        maximumFractionDigits: 0
      }).format((Number(cents) || 0) / 100)
    } catch (_error) {
      return `₹${Math.round((Number(cents) || 0) / 100).toLocaleString('en-IN')}`
    }
  }

  roots.forEach((root) => {
    const sectionId = root.dataset.sectionId
const productId = root.dataset.productId
const currency = root.dataset.currency || 'INR'
const toast = root.querySelector('[data-rm-toast]')
const variantPriceMapEl = root.querySelector('[data-rm-variant-price-map]')
let variantPriceMap = {}

try {
  variantPriceMap = variantPriceMapEl ? JSON.parse(variantPriceMapEl.textContent || '{}') : {}
} catch (error) {
  variantPriceMap = {}
}

const getSelectedVariantId = () => {
  const addToCartForm = root.querySelector('form[action*="/cart/add"]')
  const idInput =
    addToCartForm?.querySelector('[name="id"]') ||
    root.querySelector('[name="id"]')

  return idInput ? String(idInput.value) : ''
}

const renderVariantPrice = (variantData) => {
  if (!variantData) return

  const priceEl = root.querySelector('.rm-price')
  const stickyPriceEl = root.querySelector('[data-rm-sticky-price]')

  const price = Number(variantData.price || 0)
const compareAtPrice = Number(variantData.compare_at_price || 0)
const isOnSale = compareAtPrice > price
const savePercent = isOnSale
  ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
  : 0

const priceHtml = isOnSale
  ? `
    <span class="rm-pdp-price-sync rm-pdp-price-sync--sale">
      <s class="rm-pdp-price-sync-compare">${variantData.compare_at_price_formatted}</s>
  <span class="rm-pdp-price-sync-current">${variantData.price_formatted}</span>
      <span class="rm-pdp-price-sync-save">Save ${savePercent}%</span>
    </span>
  `
  : `
    <span class="rm-pdp-price-sync">
      <span>${variantData.price_formatted}</span>
    </span>
    `

  if (priceEl) priceEl.innerHTML = priceHtml
  if (stickyPriceEl) stickyPriceEl.textContent = variantData.price_formatted
}

const syncSelectedVariantPrice = () => {
  window.setTimeout(() => {
    const selectedVariantId = getSelectedVariantId()
    const variantData = variantPriceMap[selectedVariantId]

    if (variantData) {
      renderVariantPrice(variantData)
    }
  }, 40)
}

root.addEventListener('change', (event) => {
  if (
    event.target.matches('select, input[type="radio"], input[name="id"]') ||
    event.target.closest('.variant-input, .variant-button-wrap, .block-variant-picker')
  ) {
    syncSelectedVariantPrice()
  }
})

root.addEventListener('click', (event) => {
  if (event.target.closest('.variant-input, .variant-button-wrap, .block-variant-picker label')) {
    syncSelectedVariantPrice()
  }
})

document.addEventListener('variant:change', syncSelectedVariantPrice)
document.addEventListener('product:variant-change', syncSelectedVariantPrice)

syncSelectedVariantPrice()

const promiseCopy = {
  workingDaysLabel: root.dataset.promiseWorkingDaysLabel || 'working days',
  defaultEtaPrefix: root.dataset.promiseDefaultEtaPrefix || 'Default ETA',
  pinLinkText: root.dataset.promisePinLinkText || 'Add your pincode for a sharper estimate',
  savedPrefix: root.dataset.promiseSavedPrefix || 'Estimate saved for',
  savedSuffix: root.dataset.promiseSavedSuffix || 'courier confirmation happens after dispatch'
}

    const showToast = (message) => {
      if (!toast) return
      toast.textContent = message
      toast.classList.add('is-visible')
      window.clearTimeout(toast._rmTimer)
      toast._rmTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2100)
    }

    const mainImage = root.querySelector('.rm-main-media-img')
const thumbs = root.querySelectorAll('[data-rm-thumb]')
const dots = root.querySelectorAll('[data-rm-dots] span')

const updateMainGalleryImage = (thumb) => {
  if (!thumb || !mainImage) return

  const src = thumb.dataset.fullSrc
  const alt = thumb.dataset.alt || ''
  const index = Number(thumb.dataset.index || 0)

  if (!src) return

  thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb))
  dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index))

  /*
    Shopify image_tag usually prints srcset/sizes.
    If srcset remains, browser may keep loading the old first image even after src changes.
    So we clear responsive/lazy attributes before applying the selected image.
  */
  mainImage.removeAttribute('srcset')
  mainImage.removeAttribute('sizes')
  mainImage.removeAttribute('data-srcset')
  mainImage.removeAttribute('data-sizes')
  mainImage.removeAttribute('data-src')

  mainImage.src = src
  mainImage.alt = alt

  if (mainImage.dataset) {
    mainImage.dataset.currentRmImage = String(index)
  }
}

thumbs.forEach((thumb) => {
  thumb.addEventListener('click', () => {
    updateMainGalleryImage(thumb)
  })
})
/* =========================================================
   PDP v3 Variant Image Sync
   - Uses Shopify mapped variant image
   - Updates custom RareMango desktop + mobile gallery
   ========================================================= */

const normalizeRmImageKey = (src) => {
  if (!src) return ''

  try {
    const url = new URL(src, window.location.origin)
    const file = decodeURIComponent(url.pathname.split('/').pop() || '')

    return file.replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|\d+x)(?=\.)/i,
      ''
    )
  } catch (_error) {
    return String(src)
      .split('?')[0]
      .split('/')
      .pop()
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|\d+x)(?=\.)/i,
        ''
      )
  }
}

const scrollMobileGalleryToIndex = (index) => {
  if (index === null || index === undefined || index === '') return

  const mobileTrack = root.querySelector('[data-rm-mobile-track]')
  const mobileSlide = root.querySelector(`.rm-mobile-slide[data-index="${index}"]`)

  if (mobileTrack && mobileSlide) {
    mobileTrack.scrollTo({
      left: mobileSlide.offsetLeft,
      behavior: 'smooth'
    })
  }

  dots.forEach((dot, dotIndex) => {
    dot.classList.toggle('is-active', dotIndex === Number(index))
  })
}

const updateGalleryFromVariantImage = (variantData) => {
  if (!variantData || !variantData.featured_image_src || !mainImage) return

  const variantImageSrc = variantData.featured_image_src
  const variantImageAlt = variantData.featured_image_alt || ''
  const targetKey = normalizeRmImageKey(variantImageSrc)

  let matchingThumb = null

  thumbs.forEach((thumb) => {
    const thumbKey = normalizeRmImageKey(thumb.dataset.fullSrc)

    if (targetKey && thumbKey && targetKey === thumbKey) {
      matchingThumb = thumb
    }
  })

  if (matchingThumb) {
    updateMainGalleryImage(matchingThumb)
    scrollMobileGalleryToIndex(matchingThumb.dataset.index)
    return
  }

  mainImage.removeAttribute('srcset')
  mainImage.removeAttribute('sizes')
  mainImage.removeAttribute('data-srcset')
  mainImage.removeAttribute('data-sizes')
  mainImage.removeAttribute('data-src')

  mainImage.src = variantImageSrc
  mainImage.alt = variantImageAlt
}

const syncSelectedVariantImage = () => {
  window.setTimeout(() => {
    const selectedVariantId = getSelectedVariantId()
    const variantData = variantPriceMap[selectedVariantId]

    updateGalleryFromVariantImage(variantData)
  }, 90)
}

root.addEventListener('change', (event) => {
  if (
    event.target.matches('select, input[type="radio"], input[name="id"]') ||
    event.target.closest('.variant-input, .variant-button-wrap, .block-variant-picker')
  ) {
    syncSelectedVariantImage()
  }
})

root.addEventListener('click', (event) => {
  if (event.target.closest('.variant-input, .variant-button-wrap, .block-variant-picker label')) {
    syncSelectedVariantImage()
  }
})

document.addEventListener('variant:change', syncSelectedVariantImage)
document.addEventListener('product:variant-change', syncSelectedVariantImage)

document.addEventListener(`variant:change:${sectionId}:${productId}`, (event) => {
  const { variant } = event.detail || {}

  if (variant && variant.id && variantPriceMap[String(variant.id)]) {
    updateGalleryFromVariantImage(variantPriceMap[String(variant.id)])
  } else {
    syncSelectedVariantImage()
  }
})

syncSelectedVariantImage()

    const track = root.querySelector('[data-rm-mobile-track]')
    if (track && dots.length) {
      let scrollFrame
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame)
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index))
        })
      }, { passive: true })
    }

    root.querySelectorAll('.rm-gallery-toggle button').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('.rm-gallery-toggle button').forEach((item) => item.classList.remove('is-active'))
        button.classList.add('is-active')
        showToast(`${button.textContent.trim()} selected`)
      })
    })

    const saveButtons = root.querySelectorAll('[data-rm-save], [data-rm-save-link]')
    saveButtons.forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.toggle('is-active')
        saveButtons.forEach((item) => {
          if (item !== button) item.classList.toggle('is-active', button.classList.contains('is-active'))
        })
        showToast(button.classList.contains('is-active') ? 'Saved for later' : 'Removed from saved')
      })
    })

    const shareProduct = async () => {
      const title = document.title
      const url = window.location.href
      if (navigator.share) {
        try {
          await navigator.share({ title, url })
          return
        } catch (_error) {
          // fall through to clipboard
        }
      }
      try {
        await navigator.clipboard.writeText(url)
        showToast('Product link copied')
      } catch (_error) {
        showToast('Copy this page URL to share')
      }
    }

    root.querySelectorAll('[data-rm-share], [data-rm-share-link]').forEach((button) => {
      button.addEventListener('click', shareProduct)
    })

    root.querySelectorAll('[data-rm-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.rmCopy
        try {
          await navigator.clipboard.writeText(code)
          showToast(`Copied ${code}`)
        } catch (_error) {
          showToast(code)
        }
      })
    })

    const sizeModal = root.querySelector('[data-rm-size-modal]')
    root.querySelectorAll('[data-rm-open-size-guide]').forEach((button) => {
      button.addEventListener('click', () => {
        if (sizeModal) sizeModal.hidden = false
      })
    })
    root.querySelectorAll('[data-rm-close-size-guide]').forEach((button) => {
      button.addEventListener('click', () => {
        if (sizeModal) sizeModal.hidden = true
      })
    })
    if (sizeModal) {
      sizeModal.addEventListener('click', (event) => {
        if (event.target === sizeModal) sizeModal.hidden = true
      })
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') sizeModal.hidden = true
      })
    }

    const timerEl = root.querySelector('[data-rm-cutoff-timer]')
    const etaEl = root.querySelector('[data-rm-eta-date]')
    const etaSub = root.querySelector('[data-rm-eta-sub]')

    const updatePromise = (workingDays = 6, pincode = '') => {
  const eta = addWorkingDays(new Date(), workingDays)

  if (etaEl) {
    etaEl.innerHTML = `${formatDate(eta)} · ${workingDays - 1}–${workingDays} ${promiseCopy.workingDaysLabel}`
  }

  if (etaSub) {
    etaSub.innerHTML = pincode
      ? `${promiseCopy.savedPrefix} <b>${pincode}</b> · ${promiseCopy.savedSuffix}`
      : `${promiseCopy.defaultEtaPrefix} · <button type="button" data-rm-focus-pin>${promiseCopy.pinLinkText}</button>`

    const focusPin = etaSub.querySelector('[data-rm-focus-pin]')
    if (focusPin) focusPin.addEventListener('click', () => root.querySelector('[data-rm-pin-input]')?.focus())
  }
}

    const updateCountdown = () => {
      if (!timerEl) return
      const now = new Date()
      const cutoff = new Date(now)
      cutoff.setHours(18, 0, 0, 0)
      if (now > cutoff) cutoff.setDate(cutoff.getDate() + 1)
      const diff = Math.max(0, cutoff.getTime() - now.getTime())
      const hours = Math.floor(diff / 36e5)
      const minutes = Math.floor((diff % 36e5) / 6e4)
      const seconds = Math.floor((diff % 6e4) / 1000)
      timerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`
    }
    updatePromise()
    updateCountdown()
    window.setInterval(updateCountdown, 1000)

    root.querySelectorAll('[data-rm-focus-pin]').forEach((button) => {
      button.addEventListener('click', () => root.querySelector('[data-rm-pin-input]')?.focus())
    })

    const pinForm = root.querySelector('[data-rm-pin-form]')
    const pinInput = root.querySelector('[data-rm-pin-input]')
    const pinSaved = root.querySelector('[data-rm-pin-saved]')
    const pinNumber = root.querySelector('[data-rm-pin-number]')
    const pinMessage = root.querySelector('[data-rm-pin-message]')
    if (pinForm && pinInput) {
      pinForm.addEventListener('submit', (event) => {
        event.preventDefault()
        const pincode = pinInput.value.trim()
        if (!/^\d{6}$/.test(pincode)) {
          showToast('Enter a valid 6-digit pincode')
          return
        }
        const metro = ['400', '401', '110', '560', '600', '700', '500', '411', '122'].some((prefix) => pincode.startsWith(prefix))
        const days = metro ? 5 : 6
        if (pinSaved) pinSaved.classList.add('is-visible')
        if (pinNumber) pinNumber.textContent = pincode
        if (pinMessage) pinMessage.textContent = metro ? 'Metro-zone estimate saved. COD is usually available, final check happens at checkout.' : 'Pincode estimate saved. Final COD and courier availability will be confirmed at checkout.'
        updatePromise(days, pincode)
        showToast('Delivery estimate updated')
      })
    }

    root.querySelectorAll('[data-rm-reset-pin]').forEach((button) => {
      button.addEventListener('click', () => {
        if (pinInput) pinInput.value = ''
        if (pinSaved) pinSaved.classList.remove('is-visible')
        if (pinMessage) pinMessage.textContent = 'Enter your pincode to save an estimated delivery date and confirm COD availability.'
        updatePromise()
      })
    })

    const stickyAdd = root.querySelector('[data-rm-sticky-add]')
    const stickyBuy = root.querySelector('[data-rm-sticky-buy]')
    const stickyPrice = root.querySelector('[data-rm-sticky-price]')

    stickyAdd?.addEventListener('click', () => {
      const addButton = root.querySelector('.rm-buy-buttons button[name="add"]')
      if (addButton && !addButton.disabled) addButton.click()
    })

    const triggerBuyNow = () => {
  const directSelectors = [
    '#gokwik-buy-now',
    '.gokwik-buy-now',
    '.shopify-payment-button__button',
    'button.shopify-payment-button__button--unbranded'
  ]

  let buyButton = null

  for (const selector of directSelectors) {
    const candidate = root.querySelector(selector)
    if (
      candidate &&
      !candidate.disabled &&
      !candidate.hasAttribute('disabled') &&
      !candidate.matches('[data-rm-inline-buy-now], [data-rm-sticky-buy], button[name="add"]')
    ) {
      buyButton = candidate
      break
    }
  }

  if (!buyButton) {
    buyButton = Array.from(root.querySelectorAll('.rm-buy-buttons button, .rm-buy-buttons a')).find((element) => {
      const text = (element.textContent || '').trim()
      const idClass = `${element.id || ''} ${element.className || ''}`.toLowerCase()

      return (
        !element.disabled &&
        !element.hasAttribute('disabled') &&
        !element.matches('[data-rm-inline-buy-now], [data-rm-sticky-buy], button[name="add"]') &&
        (idClass.includes('gokwik') || /buy now|checkout/i.test(text))
      )
    })
  }

  if (buyButton) {
    buyButton.click()
    return
  }

  showToast('Buy Now is loading. Try again in a moment.')
}

root.querySelector('[data-rm-inline-buy-now]')?.addEventListener('click', triggerBuyNow)
stickyBuy?.addEventListener('click', triggerBuyNow)

    const syncStickyAvailability = () => {
      const addButton = root.querySelector('.rm-buy-buttons button[name="add"]')
      const disabled = addButton?.disabled || addButton?.hasAttribute('disabled')
      if (stickyAdd) stickyAdd.disabled = Boolean(disabled)
      if (stickyBuy) stickyBuy.disabled = Boolean(disabled)
    }

    document.addEventListener(`variant:change:${sectionId}:${productId}`, (event) => {
      const { variant } = event.detail || {}
      if (!variant) {
        if (stickyAdd) stickyAdd.disabled = true
        if (stickyBuy) stickyBuy.disabled = true
        return
      }
      if (stickyPrice) stickyPrice.textContent = moneyFromCents(variant.price, currency)
      window.setTimeout(syncStickyAvailability, 100)
    })

    document.addEventListener('ajaxProduct:added', () => {
      showToast('Added to cart')
    })

    const buyButtons = root.querySelector('.rm-buy-buttons')
    if (buyButtons) {
      const observer = new MutationObserver(syncStickyAvailability)
      observer.observe(buyButtons, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] })
      syncStickyAvailability()
    }
  })
})()
/* =========================================================
   RareMango PDP — Artwork Video Section
   ========================================================= */

;(() => {
  const sectionSelector = '[data-rm-ugc-section]';

  const initialiseSection = (section) => {
    if (!section || section.dataset.rmUgcReady === 'true') {
      return;
    }

    section.dataset.rmUgcReady = 'true';

    const cards = Array.from(
      section.querySelectorAll('[data-rm-ugc-card]')
    );

    if (!cards.length) {
      return;
    }

    const restartOnSound =
      section.dataset.restartOnSound === 'true';

    const connection = navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    const reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const saveData =
      connection &&
      connection.saveData === true;

    const slowConnection =
      connection &&
      ['slow-2g', '2g'].includes(connection.effectiveType);

    const allowAutoplay =
      !reducedMotion &&
      !saveData &&
      !slowConnection;

    const getVideo = (card) =>
      card.querySelector('[data-rm-ugc-video]');

    const getSource = (card) =>
      card.querySelector('[data-rm-ugc-source]');

    const getSoundButton = (card) =>
      card.querySelector('[data-rm-ugc-sound]');

    const getPlayButton = (card) =>
      card.querySelector('[data-rm-ugc-play]');

    const setSoundButton = (card, soundOn) => {
      const button = getSoundButton(card);

      if (!button) return;

      button.hidden = false;
      button.setAttribute(
        'aria-pressed',
        soundOn ? 'true' : 'false'
      );

      button.setAttribute(
        'aria-label',
        soundOn ? 'Turn sound off' : 'Turn sound on'
      );
    };

    const muteCard = (card) => {
      const video = getVideo(card);

      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');

      setSoundButton(card, false);
    };

    const muteOtherCards = (activeCard) => {
      cards.forEach((card) => {
        if (card !== activeCard) {
          muteCard(card);
        }
      });
    };

    const hydrateVideo = (card) => {
      const video = getVideo(card);
      const source = getSource(card);

      if (!video || !source) {
        return null;
      }

      if (video.dataset.rmLoaded === 'true') {
        return video;
      }

      const videoUrl = source.dataset.src;

      if (!videoUrl) {
        console.warn(
          'RareMango UGC: No video source found.',
          card
        );

        return null;
      }

      source.src = videoUrl;

      video.dataset.rmLoaded = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      setSoundButton(card, false);

      video.addEventListener('playing', () => {
        card.classList.add('is-playing');

        const playButton = getPlayButton(card);

        if (playButton) {
          playButton.hidden = true;
        }
      });

      video.addEventListener('error', () => {
        console.warn(
          'RareMango UGC: Video failed to load.',
          video.currentSrc || videoUrl
        );

        const playButton = getPlayButton(card);

        if (playButton) {
          playButton.hidden = false;
        }
      });

      video.load();

      return video;
    };

    const showManualPlay = (card) => {
      const playButton = getPlayButton(card);

      if (playButton) {
        playButton.hidden = false;
      }
    };

    const playCard = async (card) => {
      const video = hydrateVideo(card);

      if (!video) {
        showManualPlay(card);
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');

      try {
        await video.play();
      } catch (firstError) {
        /*
         * Some browsers need the video to reach canplay before
         * accepting the muted autoplay request.
         */
        const retryPlayback = async () => {
          try {
            video.muted = true;
            video.defaultMuted = true;
            video.setAttribute('muted', '');

            await video.play();
          } catch (secondError) {
            showManualPlay(card);
          }
        };

        if (video.readyState >= 3) {
          retryPlayback();
        } else {
          video.addEventListener(
            'canplay',
            retryPlayback,
            { once: true }
          );

          window.setTimeout(() => {
            if (video.paused) {
              showManualPlay(card);
            }
          }, 2500);
        }
      }
    };

    section.addEventListener('click', async (event) => {
      const soundButton = event.target.closest(
        '[data-rm-ugc-sound]'
      );

      if (soundButton) {
        const card = soundButton.closest(
          '[data-rm-ugc-card]'
        );

        const video = hydrateVideo(card);

        if (!video) return;

        if (video.muted) {
          muteOtherCards(card);

          video.muted = false;
          video.defaultMuted = false;
          video.removeAttribute('muted');
          video.volume = 1;

          if (restartOnSound) {
            video.currentTime = 0;
          }

          setSoundButton(card, true);

          try {
            await video.play();
          } catch (error) {
            console.warn(
              'RareMango UGC: Sound playback was blocked.',
              error
            );
          }
        } else {
          muteCard(card);
        }

        return;
      }

      const playButton = event.target.closest(
        '[data-rm-ugc-play]'
      );

      if (playButton) {
        const card = playButton.closest(
          '[data-rm-ugc-card]'
        );

        const video = hydrateVideo(card);

        if (!video) return;

        playButton.hidden = true;

        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');

        try {
          await video.play();
        } catch (error) {
          playButton.hidden = false;
        }
      }
    });

    /*
     * Load shortly before the card enters view.
     * Pause and re-mute when it leaves.
     */
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            const video = getVideo(card);

            if (
              entry.isIntersecting &&
              entry.intersectionRatio > 0
            ) {
              if (allowAutoplay) {
                playCard(card);
              } else {
                hydrateVideo(card);
                showManualPlay(card);
              }
            } else if (video) {
              video.pause();
              muteCard(card);
            }
          });
        },
        {
          root: null,
          rootMargin: '180px 80px 180px 80px',
          threshold: [0, 0.01, 0.25]
        }
      );

      cards.forEach((card) => {
        observer.observe(card);
      });
    } else {
      /*
       * Fallback for browsers without IntersectionObserver.
       */
      cards.forEach((card) => {
        if (allowAutoplay) {
          playCard(card);
        } else {
          hydrateVideo(card);
          showManualPlay(card);
        }
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) return;

      cards.forEach((card) => {
        const video = getVideo(card);

        if (video) {
          video.pause();
        }

        muteCard(card);
      });
    });
  };

  const initialiseAllSections = (scope = document) => {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches(sectionSelector)
    ) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections.push(
        ...scope.querySelectorAll(sectionSelector)
      );
    }

    sections.forEach(initialiseSection);
  };

  const start = () => {
    initialiseAllSections(document);
  };

  /*
   * This is important because the asset is loaded with `defer`,
   * but Shopify's theme editor can also inject the section later.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAllSections(event.target);
    }
  );
})();